import _get from 'lodash/get';
import {
  getVideoId,
  getIsEnded,
  getDurationInSeconds,
  getElapsedTimeInSeconds,
  getCurrentMetadataItem,
  isAdMode,
} from './player.selectors';
import { getCurrentSectionCode } from '../layout/layout.selectors';
import { ADVISORY_DISPLAY_DURATION_IN_SECONDS } from './video.constants';

export const getNextVideoItem = state => {
  const section = getCurrentSectionCode(state);
  const layout = _get(state, `layout.${section}.video.${getVideoId(state)}`);

  return _get(layout, 'blocks[0].content.items', []).find(item => item.itemType === 'classic');
};

export const getCurrentVideoItem = state => getCurrentMetadataItem(state);

export const hasNextVideo = state => Boolean(getNextVideoItem(state));

export const shouldDisplayNextVideo = state => getIsEnded(state) && hasNextVideo(state);

export const getCurrentChapter = state => (isAdMode(state) || getIsEnded(state) ? null : state.player.chapter);

export const isVideoEnding = state => {
  const timeLeft = getDurationInSeconds(state) - getElapsedTimeInSeconds(state);

  return timeLeft >= 0 && timeLeft <= ADVISORY_DISPLAY_DURATION_IN_SECONDS;
};
